import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addQuarterMark'
})
export class AddQuarterMarkPipe implements PipeTransform {
    transform(string: string) {
        return `"${string}"`;
    }
}
